// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4067":"ffde425c","9807":"ffde425c"}[chunkId] + ".chunk.css";
};